import * as tslib_1 from "tslib";
// Core packages
import { OnDestroy, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";
// Third party packages
import { MatDialogRef } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";
import moment from "moment";
import { CookieService } from "ngx-cookie-service";
// Custom packages
import { AuthService } from "src/app/modules/auth/auth.service";
import { User } from "src/app/shared/models/user/user.model";
import { ApiService } from "src/app/shared/services/api.service";
import { ConfigService } from "src/app/shared/services/config.service";
import { PlatformNotesService } from "../../platformNotes.service";
var ViewPlatformNotesDialogComponent = /** @class */ (function () {
    /**
     * Class constructor
     */
    function ViewPlatformNotesDialogComponent(dialogRef, data, configService, cookieService, translateService, authService, platformNotesService, apiService) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.configService = configService;
        this.cookieService = cookieService;
        this.translateService = translateService;
        this.authService = authService;
        this.platformNotesService = platformNotesService;
        this.apiService = apiService;
        this.subscriptions = [];
        this.user = new User();
        this.lang = this.translateService.currentLang || this.translateService.defaultLang;
        // BEGIN - Add subUser form
        // BEGIN - ngx-formly
        this.form = new FormGroup({});
        this.model = {};
        this.fields = [];
        this.options = {};
        // END - ngx-formly
        this.formBtnOptions = {
            active: false,
            text: this.translateService.instant("common.cta.add"),
            spinnerSize: 19,
            raised: true,
            stroked: true,
            flat: false,
            fab: false,
            buttonColor: "primary",
            spinnerColor: "primary",
            fullWidth: false,
            disabled: false,
            mode: "indeterminate",
            buttonIcon: {
                fontSet: "fal",
                fontIcon: "fa-save",
                inline: true
            }
        };
        // END - Add subUser form
        this.dialogIsLoading = true;
        this.propertyId = '';
        this.companyId = '';
        this.propertyIdBalances = '';
        this.companyIdBalances = '';
        this.notesBalance = [];
        this.notesProperty = [];
        this.notesCompany = [];
        this.sortedDataBalance = [];
        this.sortedDataProperty = [];
        this.sortedDataCompany = [];
        dialogRef.disableClose = true;
    }
    /**
     * Init component
     *
     */
    ViewPlatformNotesDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        // Get logged user data
        this.subscriptions.push(this.authService.loggedUser$.subscribe(function (res) { return (_this.loggedUser = res); }));
        // Get current lang
        this.lang =
            this.cookieService.get("lang") || this.configService.defaultLang;
        // View data
        if (this.data && this.data.propertyId) {
            this.propertyId = this.data.propertyId;
            this.subscriptions.push(this.platformNotesService.getProperty(this.propertyId, 0, 100)
                .subscribe(function (res) {
                var e_1, _a;
                if (res.data.items && Array.isArray(res.data.items)) {
                    try {
                        for (var _b = tslib_1.__values(res.data.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                            var item = _c.value;
                            var createdBy = item.createdBy.firstName + " " + item.createdBy.lastName;
                            var createdAt = '';
                            if (item.createdAt &&
                                moment(item.createdAt).isValid()) {
                                createdAt = moment(item.createdAt).format("DD/MM/YYYY hh:mm");
                            }
                            var category = '';
                            switch (item.category) {
                                case "subscription":
                                    category = _this.translateService.instant("platformNotes.categories.subscription");
                                    break;
                                case "work-account":
                                    category = _this.translateService.instant("platformNotes.categories.work-account");
                                    break;
                                case "technical-operational":
                                    category = _this.translateService.instant("platformNotes.categories.technical-operational");
                                    break;
                                case "insertion":
                                    category = _this.translateService.instant("platformNotes.categories.insertion");
                                    break;
                                case "mapping":
                                    category = _this.translateService.instant("platformNotes.categories.mapping");
                                    break;
                                case "packaging":
                                    category = _this.translateService.instant("platformNotes.categories.packaging");
                                    break;
                                case "tagnfc":
                                    category = _this.translateService.instant("platformNotes.categories.tagnfc");
                                    break;
                                case "suppliers":
                                    category = _this.translateService.instant("platformNotes.categories.suppliers");
                                    break;
                                case "other":
                                    category = _this.translateService.instant("platformNotes.categories.other");
                                    break;
                            }
                            if (item.createdIn === 'company') {
                                _this.notesCompany.push({
                                    category: category,
                                    createdBy: createdBy,
                                    createdAt: createdAt,
                                    title: item.title,
                                    description: item.description,
                                    originalName: item.file && item.file.originalName ? item.file.originalName : '',
                                    file: item.file
                                });
                            }
                            else {
                                var property = item.properties.map(function (el) { return el.name; }).join();
                                _this.notesProperty.push({
                                    property: property,
                                    category: category,
                                    createdBy: createdBy,
                                    createdAt: createdAt,
                                    title: item.title,
                                    description: item.description,
                                    originalName: item.file && item.file.originalName ? item.file.originalName : '',
                                    file: item.file
                                });
                            }
                        }
                    }
                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                    finally {
                        try {
                            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                        }
                        finally { if (e_1) throw e_1.error; }
                    }
                    _this.sortedDataCompany = _this.notesCompany.slice();
                    _this.sortedDataProperty = _this.notesProperty.slice();
                    _this.sortDataCompany({ active: "createdAt", direction: "desc" });
                    _this.sortDataProperty({ active: "createdAt", direction: "desc" });
                }
                // Stop loading dialog
                _this.dialogIsLoading = false;
            }));
        }
        else if (this.data && this.data.companyId) {
            this.companyId = this.data.companyId;
            this.subscriptions.push(this.platformNotesService.getCompanyWithProperties(this.companyId, 0, 100)
                .subscribe(function (res) {
                var e_2, _a;
                if (res.data.items && Array.isArray(res.data.items)) {
                    try {
                        for (var _b = tslib_1.__values(res.data.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                            var item = _c.value;
                            var createdBy = item.createdBy.firstName + " " + item.createdBy.lastName;
                            var createdAt = '';
                            if (item.createdAt &&
                                moment(item.createdAt).isValid()) {
                                createdAt = moment(item.createdAt).format("DD/MM/YYYY hh:mm");
                            }
                            var category = '';
                            switch (item.category) {
                                case "subscription":
                                    category = _this.translateService.instant("platformNotes.categories.subscription");
                                    break;
                                case "work-account":
                                    category = _this.translateService.instant("platformNotes.categories.work-account");
                                    break;
                                case "technical-operational":
                                    category = _this.translateService.instant("platformNotes.categories.technical-operational");
                                    break;
                                case "insertion":
                                    category = _this.translateService.instant("platformNotes.categories.insertion");
                                    break;
                                case "mapping":
                                    category = _this.translateService.instant("platformNotes.categories.mapping");
                                    break;
                                case "packaging":
                                    category = _this.translateService.instant("platformNotes.categories.packaging");
                                    break;
                                case "tagnfc":
                                    category = _this.translateService.instant("platformNotes.categories.tagnfc");
                                    break;
                                case "suppliers":
                                    category = _this.translateService.instant("platformNotes.categories.suppliers");
                                    break;
                                case "other":
                                    category = _this.translateService.instant("platformNotes.categories.other");
                                    break;
                            }
                            if (item.createdIn === 'company') {
                                _this.notesCompany.push({
                                    category: category,
                                    createdBy: createdBy,
                                    createdAt: createdAt,
                                    title: item.title,
                                    description: item.description,
                                    originalName: item.file && item.file.originalName ? item.file.originalName : '',
                                    file: item.file
                                });
                            }
                            else {
                                var property = item.properties.map(function (el) { return el.name; }).join();
                                _this.notesProperty.push({
                                    property: property,
                                    category: category,
                                    createdBy: createdBy,
                                    createdAt: createdAt,
                                    title: item.title,
                                    description: item.description,
                                    originalName: item.file && item.file.originalName ? item.file.originalName : '',
                                    file: item.file
                                });
                            }
                        }
                    }
                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                    finally {
                        try {
                            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                        }
                        finally { if (e_2) throw e_2.error; }
                    }
                    _this.sortedDataCompany = _this.notesCompany.slice();
                    _this.sortedDataProperty = _this.notesProperty.slice();
                    _this.sortDataCompany({ active: "createdAt", direction: "desc" });
                    _this.sortDataProperty({ active: "createdAt", direction: "desc" });
                }
                // Stop loading dialog
                _this.dialogIsLoading = false;
            }));
        }
        else if (this.data && this.data.propertyIdBalances) {
            this.propertyIdBalances = this.data.propertyIdBalances;
            this.subscriptions.push(this.platformNotesService.getPropertyBalancesNotes(this.propertyIdBalances)
                .subscribe(function (res) {
                var e_3, _a;
                if (res.data.items && Array.isArray(res.data.items)) {
                    try {
                        for (var _b = tslib_1.__values(res.data.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                            var item = _c.value;
                            var createdBy = item.createdBy.firstName + " " + item.createdBy.lastName;
                            var createdAt = '';
                            if (item.createdAt &&
                                moment(item.createdAt).isValid()) {
                                createdAt = moment(item.createdAt).format("DD/MM/YYYY hh:mm");
                            }
                            var category = '';
                            switch (item.category) {
                                case "subscription":
                                    category = _this.translateService.instant("platformNotes.categories.subscription");
                                    break;
                                case "work-account":
                                    category = _this.translateService.instant("platformNotes.categories.work-account");
                                    break;
                                case "technical-operational":
                                    category = _this.translateService.instant("platformNotes.categories.technical-operational");
                                    break;
                                case "insertion":
                                    category = _this.translateService.instant("platformNotes.categories.insertion");
                                    break;
                                case "mapping":
                                    category = _this.translateService.instant("platformNotes.categories.mapping");
                                    break;
                                case "packaging":
                                    category = _this.translateService.instant("platformNotes.categories.packaging");
                                    break;
                                case "tagnfc":
                                    category = _this.translateService.instant("platformNotes.categories.tagnfc");
                                    break;
                                case "suppliers":
                                    category = _this.translateService.instant("platformNotes.categories.suppliers");
                                    break;
                                case "other":
                                    category = _this.translateService.instant("platformNotes.categories.other");
                                    break;
                            }
                            _this.notesBalance.push({
                                balance: item.balance,
                                category: category,
                                createdBy: createdBy,
                                createdAt: createdAt,
                                title: item.title,
                                description: item.text,
                                originalName: item.file && item.file.originalName ? item.file.originalName : '',
                                file: item.file
                            });
                        }
                    }
                    catch (e_3_1) { e_3 = { error: e_3_1 }; }
                    finally {
                        try {
                            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                        }
                        finally { if (e_3) throw e_3.error; }
                    }
                    _this.sortedDataBalance = _this.notesBalance.slice();
                    _this.sortDataBalance({ active: "createdAt", direction: "desc" });
                }
                // Stop loading dialog
                _this.dialogIsLoading = false;
            }));
        }
        else if (this.data && this.data.companyIdBalances) {
            this.companyIdBalances = this.data.companyIdBalances;
            this.subscriptions.push(this.platformNotesService.getCompanyBalancesNotes(this.companyIdBalances)
                .subscribe(function (res) {
                var e_4, _a;
                if (res.data.items && Array.isArray(res.data.items)) {
                    try {
                        for (var _b = tslib_1.__values(res.data.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                            var item = _c.value;
                            var createdBy = item.createdBy.firstName + " " + item.createdBy.lastName;
                            var createdAt = '';
                            if (item.createdAt &&
                                moment(item.createdAt).isValid()) {
                                createdAt = moment(item.createdAt).format("DD/MM/YYYY hh:mm");
                            }
                            var category = '';
                            switch (item.category) {
                                case "subscription":
                                    category = _this.translateService.instant("platformNotes.categories.subscription");
                                    break;
                                case "work-account":
                                    category = _this.translateService.instant("platformNotes.categories.work-account");
                                    break;
                                case "technical-operational":
                                    category = _this.translateService.instant("platformNotes.categories.technical-operational");
                                    break;
                                case "insertion":
                                    category = _this.translateService.instant("platformNotes.categories.insertion");
                                    break;
                                case "mapping":
                                    category = _this.translateService.instant("platformNotes.categories.mapping");
                                    break;
                                case "packaging":
                                    category = _this.translateService.instant("platformNotes.categories.packaging");
                                    break;
                                case "tagnfc":
                                    category = _this.translateService.instant("platformNotes.categories.tagnfc");
                                    break;
                                case "suppliers":
                                    category = _this.translateService.instant("platformNotes.categories.suppliers");
                                    break;
                                case "other":
                                    category = _this.translateService.instant("platformNotes.categories.other");
                                    break;
                            }
                            _this.notesBalance.push({
                                balance: item.balance,
                                category: category,
                                createdBy: createdBy,
                                createdAt: createdAt,
                                title: item.title,
                                description: item.text,
                                originalName: item.file && item.file.originalName ? item.file.originalName : '',
                                file: item.file
                            });
                        }
                    }
                    catch (e_4_1) { e_4 = { error: e_4_1 }; }
                    finally {
                        try {
                            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                        }
                        finally { if (e_4) throw e_4.error; }
                    }
                    _this.sortedDataBalance = _this.notesBalance.slice();
                    _this.sortDataBalance({ active: "createdAt", direction: "desc" });
                }
                // Stop loading dialog
                _this.dialogIsLoading = false;
            }));
        }
        else {
            // Stop loading dialog
            this.dialogIsLoading = false;
        }
    };
    /**
     * Handle component destroy
     *
     * @since 1.0.0
     */
    ViewPlatformNotesDialogComponent.prototype.ngOnDestroy = function () {
        // Unsubscribe from all subscriptions
        this.subscriptions.forEach(function (sub) { return sub.unsubscribe(); });
    };
    /**
     * Handle dialog closing
     *
     * @since 1.0.0
     */
    ViewPlatformNotesDialogComponent.prototype.onClose = function () {
        this.dialogRef.close();
    };
    /**
     * Prints the whole HTML contained in "dataToPrint" element
     *
     * @since 1.0.0
     */
    ViewPlatformNotesDialogComponent.prototype.onPrint = function () {
        var title = this.translateService.instant("platformNotes.dialog.propertyNotes.title");
        title = title.replace(" ", "-");
        var printData = document.getElementById('dataToPrint').innerHTML;
        var openWindow = window.open("", title, "");
        openWindow.document.write('<style type="text/css">');
        openWindow.document.write('  @media print {');
        openWindow.document.write('    .clickable .mat-sort-header-container {');
        openWindow.document.write('      text-align: start !important;');
        openWindow.document.write('    }');
        openWindow.document.write('    .clickable .mat-sort-header-container .mat-sort-header-button{');
        openWindow.document.write('      border-width: 0px !important;');
        openWindow.document.write('      background-color: #FFF;');
        openWindow.document.write('    }');
        openWindow.document.write('  }');
        openWindow.document.write('</style>');
        openWindow.document.write(printData);
        openWindow.document.close();
        openWindow.focus();
        openWindow.print();
        openWindow.close();
    };
    /**
     * Handle table sort
     *
     * @since 1.0.0
     */
    ViewPlatformNotesDialogComponent.prototype.sortDataCompany = function (sort) {
        var _this = this;
        var data = this.sortedDataCompany.slice();
        if (!sort.active || sort.direction === "") {
            this.sortedDataCompany = data;
            return;
        }
        this.sortedDataCompany = data.sort(function (a, b) {
            var isAsc = sort.direction === "asc";
            switch (sort.active) {
                case "category":
                    return _this.compare(a.category, b.category, isAsc);
                case "title":
                    return _this.compare(a.title, b.title, isAsc);
                case "description":
                    return _this.compare(a.description, b.description, isAsc);
                case "createdAt":
                    return _this.compare(a.createdAt, b.createdAt, isAsc);
                case "createdBy":
                    return _this.compare(a.createdBy, b.createdBy, isAsc);
                case "originalName":
                    return _this.compare(a.originalName, b.originalName, isAsc);
                default:
                    return 0;
            }
        });
    };
    ViewPlatformNotesDialogComponent.prototype.sortDataProperty = function (sort) {
        var _this = this;
        var data = this.sortedDataProperty.slice();
        if (!sort.active || sort.direction === "") {
            this.sortedDataProperty = data;
            return;
        }
        this.sortedDataProperty = data.sort(function (a, b) {
            var isAsc = sort.direction === "asc";
            switch (sort.active) {
                case "property":
                    return _this.compare(a.property, b.property, isAsc);
                case "category":
                    return _this.compare(a.category, b.category, isAsc);
                case "title":
                    return _this.compare(a.title, b.title, isAsc);
                case "description":
                    return _this.compare(a.description, b.description, isAsc);
                case "createdAt":
                    return _this.compare(a.createdAt, b.createdAt, isAsc);
                case "createdBy":
                    return _this.compare(a.createdBy, b.createdBy, isAsc);
                case "originalName":
                    return _this.compare(a.originalName, b.originalName, isAsc);
                default:
                    return 0;
            }
        });
    };
    ViewPlatformNotesDialogComponent.prototype.sortDataBalance = function (sort) {
        var _this = this;
        var data = this.sortedDataBalance.slice();
        if (!sort.active || sort.direction === "") {
            this.sortedDataBalance = data;
            return;
        }
        this.sortedDataBalance = data.sort(function (a, b) {
            var isAsc = sort.direction === "asc";
            switch (sort.active) {
                case "category":
                    return _this.compare(a.category, b.category, isAsc);
                case "title":
                    return _this.compare(a.title, b.title, isAsc);
                case "description":
                    return _this.compare(a.description, b.description, isAsc);
                case "createdAt":
                    return _this.compare(a.createdAt, b.createdAt, isAsc);
                case "createdBy":
                    return _this.compare(a.createdBy, b.createdBy, isAsc);
                case "originalName":
                    return _this.compare(a.originalName, b.originalName, isAsc);
                default:
                    return 0;
            }
        });
    };
    /**
     * Utility per table sort
     *
     * @since 1.0.0
     */
    ViewPlatformNotesDialogComponent.prototype.compare = function (a, b, isAsc) {
        if (typeof a === 'string') {
            a = a.toLowerCase();
        }
        if (typeof b === 'string') {
            b = b.toLowerCase();
        }
        return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
    };
    return ViewPlatformNotesDialogComponent;
}());
export { ViewPlatformNotesDialogComponent };
